if (!customElements.get('content-carousel')) {
  customElements.define(
    'content-carousel',
    class ContentCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-content-carousel-track]');
        this.prevButton = this.querySelector('[data-content-carousel-prev]');
        this.nextButton = this.querySelector('[data-content-carousel-next]');
        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onUpdate = () => this.update();

        this.prevButton.addEventListener('click', this.onPrev);
        this.nextButton.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onUpdate, { passive: true });
        this.resizeObserver = new ResizeObserver(this.onUpdate);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (!this.track || !this.onUpdate) return;
        this.prevButton.removeEventListener('click', this.onPrev);
        this.nextButton.removeEventListener('click', this.onNext);
        this.track.removeEventListener('scroll', this.onUpdate);
        this.resizeObserver.disconnect();
      }

      move(direction) {
        const slide = this.track.firstElementChild;
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: direction * (slide.getBoundingClientRect().width + gap),
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.prevButton.hidden = this.track.scrollLeft <= 1;
        this.nextButton.hidden = maxScroll <= 1 || this.track.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
